import {css} from 'emotion'

export const FaqPopinStyle = () => css({
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  backgroundColor: 'rgba(255, 255, 255, .9)',
  zIndex: 100,
  visibility: 'hidden',
  opacity: 0,
  transition: '.4s ease-in-out visibility, .4s ease-in-out opacity',
  '&.is-open': {
    visibility: 'visible',
    opacity: 1
  },
  '.popin-inner': {
    position: 'relative',
    width: 880,
    maxWidth: 'calc(100vw - 80px)',
    padding: 80,
    border: '1px solid #D8D8D8',
    backgroundColor: '#FFF',
    '@media (max-width: 767px)': {
      padding: '2rem',
    },
    '.error': {
      fontWeight: 300,
      fontSize: '1rem'
    }
  },
  '.popin-close': {
    position: 'absolute',
    top: 30,
    right: 30,
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    margin: 0,
    padding: 0
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/faqPopin.js